import styled from '@emotion/styled';
import MessageWrapperBase from './MessageWrapperBase';
import { FormattedMessage } from 'react-intl';

const MessageWrapper = styled(MessageWrapperBase)({
  paddingTop: 64,
  paddingBottom: 64,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  'h4, p': {
    width: 400,
    maxWidth: 'calc(100% - 24px)',
    textAlign: 'center',
  },
  p: {
    marginTop: 10,
  },
});

const EmptyOneDriveMessage = () => (
  <MessageWrapper>
    <h4>
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.messages.empty_onedrive.title" />
    </h4>
    <p>
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.messages.empty_onedrive.text" />
    </p>
  </MessageWrapper>
);

export default EmptyOneDriveMessage;
